/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React, { Component, ReactComponentElement } from 'react';

// ours
import BottomButtons from '../bottom-buttons/BottomButtons';
import CardNameEdit from '../card-name-edit/CardNameEdit';
import CardTop from '../card-top/CardTop';
import CashFlowService from '../../services/cashflow.service';
import DatePickers from '../date-pickers/DatePickers';
import Drawer from '../drawer/Drawer';
import DrawerIntro from '../drawer-intro/DrawerIntro';
import { GoalDrawerViewModel } from 'src/types/view-models/goal-drawer.view.model';
import InfoCallout from '../callout/InfoCallout';

// styles
import './GoalDrawer.module.scss';
import LiteralsService from 'src/services/literals/LiteralsService';

export default class GoalDrawer extends Component<GoalDrawerViewModel> {
    public override state = {
        editingName: false
    };

    public override render(): ReactComponentElement<any> {
        // Get the drawer title, either using the configured card name, or finding the default name for the card
        const title =
            this.props.drawerProps.card.nickname ||
            LiteralsService.getLiteral(`Goals.${this.props.drawerProps.card.description.toLowerCase()}`);

        return (
            <Drawer
                drawerProps={this.props.drawerProps}
                handleBack={this.props.handleBack}
                header={
                    <CardTop
                        card={this.props.drawerProps.card}
                        icon={this.props.icon}
                        handleUpdateCard={this.props.handleUpdateCard}
                        handleChangeCard={this.props.handleChangeCard}
                        editingName={this.state.editingName}
                        toggleEditingName={() => {
                            this.setState({ editingName: !this.state.editingName });
                        }}
                    />
                }
                title={title}
                withBackButton
            >
                {this.state.editingName && (
                    <CardNameEdit
                        card={this.props.drawerProps.card}
                        handleUpdateCard={this.props.handleUpdateCard}
                        handleChangeCard={this.props.handleChangeCard}
                        toggleEditingName={() => {
                            this.setState({ editingName: !this.state.editingName });
                        }}
                    />
                )}

                <DrawerIntro
                    content={this.props.introContent}
                    learnMoreUrl={this.props.learnMoreUrl}
                    learnMoreContent={this.props.learnMoreContent}
                />

                <div className="drawerSection">
                    <DatePickers
                        startDateLabel={this.props.startDateLabel || 'Planned start date'}
                        startDate={this.props.drawerProps.card.startDate}
                        endDateLabel={this.props.endDateLabel || 'Planned end date'}
                        endDate={this.props.drawerProps.card.endDate}
                        noEndPicker={!this.props.hasEndDate}
                        maxDate={this.props.maxEndDate || CashFlowService.getLastCashFlow(this.props.cashFlow).endDate}
                        handleChangeDate={this.props.handleChangeCardDate.bind(this)}
                    />
                    {this.props.datePickerCalloutContent && (
                        <InfoCallout text={this.props.datePickerCalloutContent} noMargin />
                    )}
                </div>

                {this.props.children}

                <BottomButtons
                    setUpdated
                    drawerProps={this.props.drawerProps}
                    handleBack={this.props.handleBack}
                    handleUpdateCard={this.props.bottomButtonUpdate || this.props.handleUpdateCard}
                    handleDeleteCard={this.props.handleDeleteCard}
                    showLoader={this.props.showLoader}
                    hideLoader={this.props.hideLoader}
                    updateAction={this.props.updateAction}
                    afterUpdateAction={this.props.afterUpdateAction}
                />
            </Drawer>
        );
    }
}
